import React, { useEffect } from "react";
import axios from "axios";
import { Button } from "@opendate-app/setlist";

import CampaignsTab from "./CampaignsTab";
import { PROMOTION_MENU_ITEM } from "../constants/confirmTicketingConstants";

const headerStyle = {
  fontSize: "22px",
  fontWeight: "strong"
};

const footerStyle = {
  width: "100%"
};

const buttonContainerStyle = {
  height: "130px"
};

const Automations = ({
  csrfToken,
  team,
  confirm,
  activeMenuItemChanged,
}) => {
  useEffect(() => { axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken; }, [csrfToken]);

  return (
    <div className="row">
      <div className="col-12">
        <h3 style={headerStyle}>
          <strong>
            Automations
          </strong>
        </h3>
        <CampaignsTab
          csrfToken={csrfToken}
          team={team}
          venueOwnershipId={confirm.venue_ownership.id}
          overridable={{ type: "Confirm", id: confirm.id }}
        />
      </div>
      <div className="row" style={footerStyle}>
        <div className="col-12 d-flex justify-content-end align-items-end" style={buttonContainerStyle}>
          <Button variant="primary"
                  onClick={() => activeMenuItemChanged(PROMOTION_MENU_ITEM)}>
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Automations;
